import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Framework from "@/pages/Framework";
import Services from "@/pages/Services";
import WhyIndia from "@/pages/WhyIndia";
import WhyNoida from "@/pages/WhyNoida";
import Industries from "@/pages/Industries";
import Resources from "@/pages/Resources";
import BlogPost from "@/pages/BlogPost";
import Assessment from "@/pages/Assessment";
import Contact from "@/pages/Contact";
import Stories from "@/pages/Stories";
import StoryPage from "@/pages/StoryPage";

function App() {
  return (
    <div className="App font-body">
      <Toaster position="top-center" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/framework" element={<Framework />} />
            <Route path="/services" element={<Services />} />
            <Route path="/why-india" element={<WhyIndia />} />
            <Route path="/why-noida" element={<WhyNoida />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<BlogPost />} />
            <Route path="/stories" element={<Stories />} />
            <Route path="/stories/:slug" element={<StoryPage />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
